// extracted by mini-css-extract-plugin
export default {"UploadCard":"UploadCard_UploadCard__z7SuN","UploadText":"UploadCard_UploadText__LLFfQ"};